var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductServiceTopMenu',{attrs:{"title":_vm.$t('product-service.edit-feed')}}),_c('Form',{attrs:{"is-edit":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }